type BurgerOptions = {
  burgerBtnClass?: string;
  menuClass?: string;
  linkClass?: string;
  closeBtnClass?: string;
};

export function initBurgerMenu(
  burgerBtnClass = 'js-open-filter',
  menuClass = 'js-menu-filter',
  linkClass = 'menu-link',
  closeBtnClass = 'js-close'
): { closeMenu: () => void; toggleMenu: () => void } | void {
  
  const burgerBtn = document.querySelector<HTMLElement>(`.${burgerBtnClass}`);
  const menu = document.querySelector<HTMLElement>(`.${menuClass}`);
  
  // Проверяем существование элементов
  if (!burgerBtn || !menu) return;
  
  const menuLinks = menu.querySelectorAll<HTMLElement>(`.${linkClass}`);
  const closeButton = menu.querySelector<HTMLElement>(`.${closeBtnClass}`);
  
  const toggleMenu = (): void => {
    burgerBtn.classList.toggle('active');
    menu.classList.toggle('active');
    
    document.body.style.overflow = menu.classList.contains('active')
      ? 'hidden'
      : '';
  };
  
  const closeMenu = (): void => {
    burgerBtn.classList.remove('active');
    menu.classList.remove('active');
    document.body.style.overflow = '';
  };
  
  burgerBtn.addEventListener('click', (e: MouseEvent) => {
    e.stopPropagation();
    toggleMenu();
  });
  
  if (closeButton) {
    closeButton.addEventListener('click', (e: MouseEvent) => {
      e.stopPropagation();
      closeMenu();
    });
  }
  
  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMenu();
    });
  });
  
  document.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Escape' && menu.classList.contains('active')) {
      closeMenu();
    }
  });
  
  document.addEventListener('click', (e: MouseEvent) => {
    const target = e.target;

    if (
      menu.classList.contains('active') &&
      target instanceof Node &&
      !menu.contains(target) &&
      !burgerBtn.contains(target)
    ) {
      closeMenu();
    }
  });
  
  return {
    closeMenu,
    toggleMenu
  };
}